import { color, fontSize, styled } from '@mui/system';
import Paper from '@mui/material/Paper';

import NotificationsIcon from '@mui/icons-material/Notifications';
import COLORS from '../../../theme/Colors';
import { MenuItem, MenuList } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'center',
  cursor: 'pointer',

});

export const TraslateIconStyled = styled(LanguageIcon)((props) => ({
  fontSize: '40px',
  color: COLORS.secondary,
  '&:hover,&:focus': {
    backgroundColor: COLORS.primary,
    borderRadius: '100%',
    color: COLORS.white,
    // fontSize: props.fontSize === '48px' ? fontSize : '45px,'
  },
  '@media (min-width:768px)': {
    alignItems: 'center',
  },
  '@media (min-width:1200px)': {
    // fontSize: '45px'
  },
}));

export const StyledPaper = styled(Paper)({
  boxShadow: '0 8px 10px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.30)',
  marginTop: '10px',
  width: '140px',
  backgroundColor: COLORS.white,


});

export const ListMenu = styled(MenuList)({
  // backgroundColor: 'purple',
  marginTop: '10px',
  // minWidth: '100px',

  textAlign: 'center',
});
export const TralateContainer = styled('div')(props => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  // width: '100%',
  //minHeight: '10px',
  // margin: '3px',
  //padding: '4px',
  letterSpacing: 0,
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 127, 255, 0.12)',

  }
}))


export const StyledOption = styled('option')({
  fontFamily: FONTS_FAMILY.medium.body,
  fontSize: '15px',
  fontWeight: 500,
  color: '#2f2f2b',
  padding: '10px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 1, /* number of lines to show */
  '-webkit-box-orient': 'vertical',
  '&:hover': {
    color: COLORS.primary,

  }
});

